module.exports = __webpack_public_path__ + "img/course-bigcover02.8f84cc72.png";